export const environment = {
  production: true,
    API_URL: 'https://back.libranova.corefluens.co/api/',
    enterprise: "libranova",
    api_username: 'libranova',
    api_password: 'f6yeVG2N79rL1m0',
    enable_seas: false
};
